export default __webpack_public_path__ + "static/home_oil-b0a2c750e7a96e8cfde1ee6d3d125608.jpg";